const ConstructorRenderer = {
    container: null,
    layerMap: {},
    MODE: { RIGHT: 'right', LEFT: 'left', BOTH: 'both' },

    init() {
        this.container = document.getElementById('constructor-layers-container')
        if (!window.WCCP_DATA || !window.WCCP_DATA.components)  return
        this.buildLayerMap()
        if (!window.STATE) window.STATE = { selected: {} }
        if (Object.keys(window.STATE.selected).length === 0) this.setDefaults()
        this.render()
    },

    buildLayerMap() {
        window.WCCP_DATA.components.forEach(component => {
            component.products.forEach(product => {
                const vis = product.visuals
                if (vis && (vis.layer_right_url || vis.layer_left_url)) {
                    this.layerMap[String(product.product_id)] = {
                        urlRight: vis.layer_right_url || "",
                        urlLeft: vis.layer_left_url || "",
                        side: vis.side || 'right',
                        zIndex: parseInt(vis.z_index) || 0
                    }
                }
            })
        })
    },

    getVisualMode() {
        const handingComp = window.WCCP_DATA.components.find(comp =>
            comp.products && comp.products.some(p => p.component_type === 'handing')
        )

        if (!handingComp) return this.MODE.RIGHT

        const selectedId = window.STATE.selected[handingComp.id]
        if (!selectedId) return this.MODE.RIGHT

        const product = handingComp.products.find(p => String(p.product_id) === String(selectedId))
        return product?.visuals?.side || this.MODE.RIGHT
    },


    render() {
        if (!this.container || !window.STATE.selected) return
        this.container.innerHTML = ''

        const mode = this.getVisualMode()
        const selected = window.STATE.selected
        const activeLayers = []

        Object.keys(selected).forEach(compId => {
            const productId = String(selected[compId])
            const layerData = this.layerMap[productId]

            if (layerData) {
                if (mode === this.MODE.BOTH) {
                    if (layerData.side === 'both') {
                        if (layerData.urlRight) activeLayers.push({ url: layerData.urlRight, zIndex: layerData.zIndex })
                        if (layerData.urlLeft) activeLayers.push({ url: layerData.urlLeft, zIndex: layerData.zIndex })
                    }
                    else if (layerData.side === 'left') {
                        if (layerData.urlLeft) activeLayers.push({ url: layerData.urlLeft, zIndex: layerData.zIndex })
                    } else {
                        if (layerData.urlRight) activeLayers.push({ url: layerData.urlRight, zIndex: layerData.zIndex })
                    }
                }
                else if (mode === this.MODE.LEFT) {
                    const url = layerData.urlLeft || layerData.urlRight
                    if (url) activeLayers.push({ url: url, zIndex: layerData.zIndex })
                }
                else {
                    const url = layerData.urlRight || layerData.urlLeft
                    if (url) activeLayers.push({ url: url, zIndex: layerData.zIndex })
                }
            }
        })

        activeLayers.sort((a, b) => a.zIndex - b.zIndex)
        activeLayers.forEach(layer => this.addLayer(layer.url, layer.zIndex))
    },

    addLayer(url, zIndex) {
        const img = document.createElement('img')
        img.src = url
        img.className = 'door-layer'
        // img.style.zIndex = zIndex
        img.dataset.zIndex = zIndex
        img.style.position = 'absolute'
        img.style.width = '100%'
        this.container.appendChild(img)
    },

    setDefaults() {
        if (window.WCCP_DATA.components.length > 0) {
            const first = window.WCCP_DATA.components[0]
            window.STATE.selected[first.id] = first.products[0].product_id
        }
    }
}

window.WCCP_CONSTRUCTOR_UPDATE = () => ConstructorRenderer.render()
document.addEventListener('DOMContentLoaded', () => ConstructorRenderer.init())